module.exports = __webpack_public_path__ + "media/components/home/sign-up-free/img/sign-up-free-mobile-4bc83ad6570c9b8b9b7eebf55220cbcc.jpg";